require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./en-us-project-kinshasa-multisector-development-and-urban-resilience.json") })
        }
      }, "path---en-us-project-kinshasa-multisector-development-and-urban-resilience");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---en-us-project-kinshasa-multisector-development-and-urban-resilience!./.cache/json/en-us-project-kinshasa-multisector-development-and-urban-resilience.json
// module id = 533
// module chunks = 231608221292675